import { all, put, call, takeEvery, select } from 'redux-saga/effects'
import { push } from 'connected-react-router'

import { fetchPropertiesSaga } from './properties'
import { fetchProductsSaga } from './products'
import { fetchPersonProfileSaga } from './profile'
import { fetchStatesSaga } from './states'
import { fetchInteractions } from './interactions'

import { apiError, showPopup, createStoreError } from '../helpers'
import { captureException } from '../helpers/Sentry'
import { logout } from './auth'

import { getRouter } from '../selectors'

export const initialState = {
  initialized: false,
  loading: false,
  error: false,
  loginTicketId: ''
}

export const moduleName = 'app'

export const INITIALIZE_APP_REQUEST = `${moduleName}/INITIALIZE_APP_REQUEST`
export const INITIALIZE_APP_SUCCESS = `${moduleName}/INITIALIZE_APP_SUCCESS`
export const INITIALIZE_APP_FAIL = `${moduleName}/INITIALIZE_APP_FAIL`

export const SET_LOAD_TICKET_LOGIN = `${moduleName}/SET_LOAD_TICKET_LOGIN`

export default function reducer(state = initialState, action) {
  const { type, payload } = action

  switch (type) {
    case INITIALIZE_APP_REQUEST:
      return { ...state, loading: true }

    case INITIALIZE_APP_SUCCESS:
      return { ...state, loading: false, initialized: true, loginTicketId: '' }

    case SET_LOAD_TICKET_LOGIN:
      return { ...state, loginTicketId: payload }

    default:
      return state
  }
}

export function initializeApp() {
  return {
    type: INITIALIZE_APP_REQUEST
  }
}

export function setLoadTicketLogin(payload) {
  return {
    type: SET_LOAD_TICKET_LOGIN,
    payload
  }
}

export const initializeAppSaga = function*() {
  try {
    const { loginTicketId } = yield select(({ app }) => app)
    const router = yield select(getRouter)
    yield call(fetchPropertiesSaga)
    yield call(fetchProductsSaga)
    yield call(fetchStatesSaga, false)
    yield call(fetchPersonProfileSaga)

    yield put({
      type: INITIALIZE_APP_SUCCESS
    })

    if (loginTicketId) {
      yield put(push(`/dashboard/interactions/${loginTicketId}`))
    } else if (router.location.pathname.indexOf('interactions') !== -1) {
      yield put(fetchInteractions())
    }
  } catch (e) {
    yield put(showPopup(e))
    if (e instanceof apiError) {
      const { code, message } = e
      yield put(createStoreError(INITIALIZE_APP_FAIL, { code, message }))
      if (code === 2) {
        yield put(logout())
      }
    } else {
      yield put(createStoreError(INITIALIZE_APP_FAIL))
      captureException(e)
    }
  }
}

export const saga = function*() {
  yield all([takeEvery(INITIALIZE_APP_REQUEST, initializeAppSaga)])
}
